


































import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import BookmarkMixin from './BookmarkMixin';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import * as  service from '@/store/Services/enterpriseFormService';
import store from '@/store';
@Component({
    components: {VuePersianDatetimePicker}
})
export default  class  DateBookmark extends Mixins(BookmarkMixin){

    get controlName(){
        if(this.tableRowIndex != undefined)
            return this.englishName + this.tableRowIndex;
        else return this.englishName;
    }
     created(){
        if(this.defaultValue)
        {
          
            this.value = this.defaultValue;
        }
            
        else
            this.value = ''; //this.defaultValue;
    }


    clear(){
        this.value = '';
    }

    onValueChanged(newVal: any, oldVal: any){
       
        this.$emit("value-changed",this.englishName);
        // if(this.value as string)
        //     if((this.value as string).includes("%%")){
        //         this.value =  (await service.updateParameter(store.state.ownerId,this.value) as string);
        //     }

    }
}
